import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

function toQuery(params = {}) {
  const qp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qp.set(k, v);
  });
  return qp.toString();
}

export async function getAsesores() {
  const url = `${API_BASE_URL}/api/admin/asesores`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden acceder a esta información.');
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al consultar asesores'}`);
  }

  return res.json();
}

export async function getPrestamosActivos(filters) {
  const query = toQuery(filters);
  const url = `${API_BASE_URL}/api/admin/prestamos-activos?${query}`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden ver este reporte.');
  }
  
  if (res.status === 422) {
    const body = await res.json();
    const error = new Error(body?.message || 'Error de validación');
    error.status = 422;
    error.response = { data: body };
    throw error;
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al consultar préstamos activos'}`);
  }

  return res.json();
}

export async function getEstadisticasPrestamosActivos() {
  const url = `${API_BASE_URL}/api/admin/prestamos-activos/estadisticas`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden ver estas estadísticas.');
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al consultar estadísticas'}`);
  }

  return res.json();
}

export async function getPrestamosActivosCompletos(filters) {
  const cleanFilters = {
    search: filters.search,
    asesor_id: filters.asesor_id,
    abonado_por: filters.abonado_por,
    casi_por_terminar: filters.casi_por_terminar,
    get_all: true,
  };

  const query = toQuery(cleanFilters);
  const url = `${API_BASE_URL}/api/admin/prestamos-activos?${query}`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden ver este reporte.');
  }
  
  if (res.status === 422) {
    const body = await res.json();
    const error = new Error(body?.message || 'Error de validación');
    error.status = 422;
    error.response = { data: body };
    throw error;
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al consultar préstamos activos'}`);
  }

  return res.json();
}
